import React, { useState, useEffect, useRef } from 'react'
import { message, Dropdown } from 'antd'
import classnames from 'classnames'
import './tagSelection.less'
import Icon from '../icon'
import Input from '../../baseComponent/input'
import History from './tagSelection.history'
import LoaclHistory from './tagSelection.localHistory'

const MAX_LENGTH = 21

export default function TagList({
  value,
  disabled,
  overlayStyle,
  onChange,
  maxSize = 20,
  className,
  smartTags,
  showSmartTags,
  type, 
  localKey, 
  localType, 
  closeFold, 
  wrapStyle, 
  ...otherProps }) {
  const [tags, setTags] = useState([])
  const [keyword, setKeyword] = useState('')
  const [isFold, setIsfold] = useState(true)
  const [wrapHeight, setWrapHeight] = useState(0)
  const $tagContainer = useRef()
  const [visible, setVisible] = useState(false)
  const [searchData, setSearchData] = useState([])
  useEffect(() => {
    setWrapHeight($tagContainer?.current?.scrollHeight)
  }, [tags])

  useEffect(() => {
    if (value instanceof Array) {
      // 处理新格式 [{label:'', value:id}]
      if (value.length > 0 && typeof value[0] === 'object' && value[0].hasOwnProperty('label') && value[0].hasOwnProperty('value')) {
        setTags(value)
      }
      // 处理旧格式 [string, string, ...]
      else {
        const notEmpty = value?.filter(m => m && typeof m === 'string' && m.trim())
        setTags(notEmpty.map(tag => ({ label: tag, value: null })))
      }
    }
    // 处理 Set 格式（兼容旧格式）
    if (value instanceof Set) {
      setTags(Array.from(value).map(tag => ({ label: tag, value: null })))
    }
  }, [value])
  const onAdd = (tag, id = null) => {
    // 检查是否已存在相同标签
    const existingTagIndex = tags.findIndex(t => t.label === tag)
    if (existingTagIndex === -1) {
      // 添加新标签
      const newTags = [...tags, { label: tag, value: id }]
      setTags(newTags)
      onChange && onChange(newTags)
    }
  }
  const onDelete = (tag) => {
    // 删除标签
    const newTags = tags.filter(t => t.label !== tag)
    setTags(newTags)
    onChange && onChange(newTags)
  }
  const events = {
    onAddTag: (tag, id = null) => {
      if (!tag) {
        return
      }
      if (tags.length >= maxSize) {
        message.error(`标签个数不可超过${maxSize}个哦`)
        return
      }
      onAdd?.(tag, id)
    },
    onKeyDown(e) {
      if (e.keyCode === 13) {
        if (e.target.value.trim().length <= 0) {
          return
        }
        const inputValue = e.target.value.trim()
        const firstMatchTag = searchData?.find(f=>f.tagName?.trim() === inputValue)
        // 检查搜索结果中是否有匹配的标签
        if (firstMatchTag) {
          // 使用第一条搜索结果的 id 和标签名
          events.onClickSearchItem(firstMatchTag.tagName, firstMatchTag.tagId)
        } else {
          // 没有搜索结果，使用用户输入的标签名，不设置 id 值
          events.onClickSearchItem(inputValue, null)
        }
      }
    },
    onChange(e) {
      if (e.target.value.length >= MAX_LENGTH) {
        // message.error(`单个标签字数不可超过${MAX_LENGTH - 1}字哦～`)
        return
      }
      // setLoading(!!e.target.value)
      setKeyword(e.target.value)
    },
    onClickSearchItem(tagName, tagId = null) {
      setKeyword('')
      events.onClickItem(tagName, tagId)
    },
    onClickItem(tagName, id = null) {
      if (tags.some(t => t.label === tagName)) {
        // 执行删除操作
        onDelete?.(tagName)
        return
      }
      if (tags.length >= maxSize) {
        message.error(`标签个数不可超过${maxSize}个哦`)
        return
      }
      // 添加操作
      onAdd?.(tagName, id)
    },
    onTagClick(tag, e) {
      e.stopPropagation()
      !disabled && onDelete?.(tag.label)
    },
  }
  return <div className="mn-tag-container" style={wrapStyle}>
    {tags?.length > 0 && <div className="mn-tag-wrap">
      <div className="tag-container" ref={$tagContainer} style={{ height: isFold ? 33 : '', overflow: 'hidden' }}>
        {[...tags]?.reverse().map(tag => <span
          key={tag.value}
          className="tag"
          onClick={e => events.onTagClick(tag, e)}
        >{tag.label}<Icon type="m-guanbi" /></span>)}
        {(!isFold && wrapHeight != 33) && <span className="tag tag-xiangshang" onClick={() => setIsfold(true)}><Icon type="m-Vxing_shang" /></span>}
      </div>
      {(isFold && wrapHeight != 33) && <span onClick={() => !closeFold && setIsfold(false)} className="tag tag-more">{`+${tags.length}...`}</span>}
    </div>}
    {/* 下方div给Dropdown定位用，防止添加标签后位置错误 */}
    <div style={{ position: 'relative' }}>
      <Dropdown
        visible={visible}
        onVisibleChange={vis => setVisible(vis)}
        getPopupContainer={node => node.parentElement || document.body}
        trigger="click"
        overlay={!disabled ? <div style={overlayStyle}>
          {
            type === 'fetchInterface' ? <History
              keyword={keyword}
              setKeyword={setKeyword}
              value={tags}
              smartTags={smartTags}
              showSmartTags={showSmartTags}
              onDelete={tagName => !disabled && onDelete?.(tagName)}
              onAdd={(tagName, tagId) => events.onAddTag(tagName, tagId)}
              setSearchData={setSearchData}
            /> : <LoaclHistory
              localKey={localKey}
              localType={localType}
              keyword={keyword}
              setKeyword={setKeyword}
              value={tags}
              onDelete={tagName => !disabled && onDelete?.(tagName)}
              onAdd={(tagName, tagId) => events.onAddTag(tagName, tagId)}
            />
          }
        </div> : <span />}
      >
        <div className={classnames('mn-add-inspiration-tag-wrapper', className)} {...otherProps}>
          <div className={classnames('tags', { disabled })}>
            <Input
              disabled={disabled}
              placeholder="点击输入，按回车添加"
              value={keyword}
              maxLength={20}
              onFocus={() => setVisible(true)}
              // onBlur={() => setVisible(false)}
              wrapClassName="tag-input"
              onKeyDown={e => events.onKeyDown(e)}
              onInput={e => events.onChange(e)}
            />
            <div className="suffix">{`${tags.length}/20`}</div>
          </div>
        </div>
      </Dropdown>
    </div>
  </div>
}
